import React, { useState } from "react";
import { Grid, Tab, Typography, Box, Tabs } from "@mui/material";
import { useSelector } from "react-redux";
import CourseTable from "../courses/CourseTable";
import ContentPacks from "../content-packs";
import MainCard from "../../components/cards/MainCard";
import { useLocation, useNavigate } from "react-router-dom";

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`course-overview-tabpanel-${index}`}
            aria-labelledby={`course-overview-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box>
                    {children}
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `course-overview-tab-${index}`,
        'aria-controls': `course-overview-tabpanel-${index}`,
    };
}

export default function CourseOverview() {
    const location = useLocation();
    const navigate = useNavigate();

    const searchParams = new URLSearchParams(location.search);

    const initialTab = parseInt(searchParams.get("tab")) || 0;


    const { tenancyId, featureSwitches: actualData, featureSwitchesLoading } = useSelector((state) => state.tenancy);
    const [tabValue, setTabValue] = useState(initialTab);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
        navigate(`?tab=${newValue}`, { replace: true });
    };

    // Define all possible tabs
    const allTabs = [
        {
            label: "Library",
            component: (
                <CourseTable
                    type="library"
                />
            )
        },
        {
            label: "Content Packs",
            component: (
                <ContentPacks/>
            ),
            condition: actualData?.enableContentPacks
        }
    ];

    // Filter tabs based on feature switches
    const tabs = allTabs.filter(tab => tab.condition !== false);

    return (
        <Grid container rowSpacing={4.5} columnSpacing={2.75}>
            <Grid item xs={12}>
                {/* Tabs */}
                <Box sx={{ mx: 2, mb: 2 }}>
                    <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        ariaLabel="course overview tabs"
                    >
                        {tabs.map((tab, index) => (
                            <Tab key={index} label={tab.label} {...a11yProps(index)} />
                        ))}
                    </Tabs>
                </Box>
                {tabs.map((tab, index) => (
                    <TabPanel key={index} value={tabValue} index={index}>
                        {tab.component}
                    </TabPanel>
                ))}
            </Grid>
        </Grid>
    );
}